import React, { lazy, Suspense } from 'react';
import { createRoutesFromElements, Route } from 'react-router-dom';
import { ErrorElement } from '@urc-ui/components/error-element';
import { Layout } from '@urc-ui/components/layout';

import(/* webpackChunkName: "InitUDC" */ '@urc-ui/services/init-udc');
const LazyLanding = lazy(() => import(/* webpackChunkName: "Landing" */ '@urc-ui/pages/landing'));
const LazyCreateSubscription = lazy(() => import(/* webpackChunkName: "CreateSubscription" */ '@urc-ui/pages/create-subscription'));
const LazyReportHistory = lazy(() => import(/* webpackChunkName: "ReportHistory" */ '@urc-ui/pages/view-subscription/report-history'));
const LazyReportSettings = lazy(() => import(/* webpackChunkName: "ReportSettings" */ '@urc-ui/pages/view-subscription/report-settings'));
const LazyViewSubscriptionLayout = lazy(() => import(/* webpackChunkName: "ViewSubscription" */ '@urc-ui/pages/view-subscription/layout'));
const LazyCustomRouteValidator = lazy(() => import(/* webpackChunkName: "CustomRouteValidator" */ '@urc-ui/pages/custom-route-validator'));

const Landing = () => (
  <Suspense fallback={<>...</>}>
    <LazyLanding />
  </Suspense>
);

const CreateSubscription = () => (
  <Suspense fallback={<>...</>}>
    <LazyCreateSubscription />
  </Suspense>
);

const ReportHistory = () => (
  <Suspense fallback={<>...</>}>
    <LazyReportHistory />
  </Suspense>
);

const ReportSettings = () => (
  <Suspense fallback={<>...</>}>
    <LazyReportSettings />
  </Suspense>
);

const ViewSubscriptionLayout = () => (
  <Suspense fallback={<>...</>}>
    <LazyViewSubscriptionLayout />
  </Suspense>
);

const CustomRouteValidator = () => (
  <Suspense fallback={<>...</>}>
    <LazyCustomRouteValidator />
  </Suspense>
);

enum PAGE_ID {
  ROOT = 'Root',
  LANDING = 'Landing',
  CREATE_REPORT = 'CreateReport',
  COPY_REPORT = 'CopyReport',
  VIEW_SUBSCRIPTION_ROOT = 'ViewSubscriptionRoot',
  VIEW_HISTORY = 'ViewHistory',
  VIEW_SETTINGS = 'ViewSettings',
  ERROR_404 = 'Error404'
}

const UnifiedReportCenterRoutes = createRoutesFromElements(
  <Route element={<Layout />} errorElement={<ErrorElement pageId={PAGE_ID.ROOT} />}>
    <Route index={true} element={<Landing />} errorElement={<ErrorElement pageId={PAGE_ID.LANDING} />} />
    <Route path={'new'} element={<CreateSubscription />} errorElement={<ErrorElement pageId={PAGE_ID.CREATE_REPORT} />} />
    <Route path={'copy/:subscriptionId'} element={<CreateSubscription />} errorElement={<ErrorElement pageId={PAGE_ID.COPY_REPORT} />} />
    <Route element={<ViewSubscriptionLayout />} errorElement={<ErrorElement pageId={PAGE_ID.VIEW_SUBSCRIPTION_ROOT} />}>
      <Route path='/history/:subscriptionId' element={<ReportHistory />} errorElement={<ErrorElement pageId={PAGE_ID.VIEW_HISTORY} />} />
      <Route path='/settings/:subscriptionId' element={<ReportSettings />} errorElement={<ErrorElement pageId={PAGE_ID.VIEW_SETTINGS} />} />
    </Route>
    <Route path='*' element={<CustomRouteValidator />} errorElement={<ErrorElement pageId={PAGE_ID.ERROR_404} />} />
  </Route>
);

export { UnifiedReportCenterRoutes };
